module.exports = __webpack_public_path__ + "images/favicon-16x16-14a0b38f16d47a5dadf3cb7731a77785.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/favicons/favicon-16x16.png
// module id = ./src/images/favicons/favicon-16x16.png
// module chunks = 1